module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/6@2x_1dec928b663ea2f2a06214a44efe2782.png";